import { render, staticRenderFns } from "./DrawerInstanceSettingsSection.vue?vue&type=template&id=502176e6&"
import script from "./DrawerInstanceSettingsSection.vue?vue&type=script&lang=js&"
export * from "./DrawerInstanceSettingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports